var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.reason == 1)?[_c('span',{staticClass:"badge badge-success"},[_vm._v("REACHED")])]:_vm._e(),(_vm.reason != 1 && _vm.reasons[_vm.reason])?[_c('span',{staticClass:"badge badge-danger badge-pill text-uppercase"},[_vm._v(_vm._s(_vm.reasons[_vm.reason]))])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }